import ChargeHelper from 'features/Charge/chargeHelper';
import MaintainerHelper from 'features/Maintainer/maintainerHelper';
import KTFormInput, {
    KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTFormTextArea from 'general/components/OtherKeenComponents/Forms/KTFormTextArea';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import CustomDropdown2 from 'general/components/Others/CustomDropdown2';
import AppColors from 'general/constants/AppColors';
import miscHelper from 'general/helpers/miscHelper';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';

DialogAddMaintainerTicketView.propTypes = {
    item: PropTypes.object,
    onCancel: PropTypes.func,
    onDone: PropTypes.func,
};

function DialogAddMaintainerTicketView({ item, onCancel, onDone }) {
    // MARK: ---- PROPERTIES ----
    const editMode = !!item;
    const [loading, setLoading] = useState(false);
    const [readyToValidate, setReadyToValidate] = useState(false);
    const [selectedChargeStation, setSelectedChargeStation] = useState(null);
    const [selectedChargePoint, setSelectedChargePoint] = useState(null);
    const [type, setType] = useState('');
    const [priority, setPriority] = useState('');
    const [deadline, setDeadline] = useState('');
    const [assignmentMode, setAssignmentMode] = useState('');
    const [description, setDescription] = useState('');
    const [selectedFiles, setSelectedFiles] = useState([]);

    useEffect(() => {
        if (item) {
            setSelectedChargeStation({
                id: item?.chargeStation?.stationId,
                name: item?.chargeStation?.name,
                item: item?.chargeStation,
            });
            setSelectedChargePoint({
                id: item?.chargePoint?.pointId,
                name: item?.chargePoint?.pointCode,
                item: item?.chargePoint,
            });
            setType(item?.type);
            setPriority(item?.priority);
            setDeadline(item?.deadline);
            setAssignmentMode(item?.assignmentMode);
            setDescription(item?.description);
            setSelectedFiles(item?.attachFiles);
        }
    }, [item]);

    // MARK: ---- FUNCTIONS ----
    const handleUploadFile = async () => {
        if (!selectedFiles || selectedFiles?.length === 0) {
            return [];
        }

        try {
            const uploadPromises = selectedFiles.map(async (fileObj) => {
                const res = await miscHelper.callApiUploadFile(fileObj?.file);
                return res[0]?.relativePath;
            });

            const newImagePaths = await Promise.all(uploadPromises);
            return newImagePaths.filter(path => path);
        } catch (error) {
            console.error('Error uploading files:', error);
            ToastHelper.showError('Upload file thất bại');
            return [];
        }
    };

    const handleSubmit = async () => {
        setReadyToValidate(true);
        if (
            !Utils.isValid(selectedChargeStation) ||
            !Utils.isValid(selectedChargePoint) ||
            !Utils.isValid(type) ||
            !Utils.isValid(priority) ||
            !Utils.isValid(deadline) ||
            !Utils.isValid(assignmentMode) ||
            !Utils.isValid(description)
        ) {
            ToastHelper.showError('Vui lòng nhập đầy đủ thông tin');
            return;
        }

        setLoading(true);

        const imagePaths = await handleUploadFile();

        let params = {
            stationId: selectedChargeStation?.id ?? '',
            pointId: selectedChargePoint?.id ?? '',
            type,
            priority,
            deadline,
            assignmentMode,
            description,
            attachedFiles: imagePaths?.length > 0 ? imagePaths : undefined,
        };
        params = _.pickBy(params, (value) => value !== null && value !== undefined && value !== '');
        if (!editMode) {
            if (assignmentMode === 'SELF') params.status = 'TODO';
            const res = await MaintainerHelper.API.requestCreateTicket(params);
            if (_.isObject(res) && res) {
                ToastHelper.showSuccess('Thêm mới công việc thành công');
                onDone && onDone();
            } else if (_.isString(res)) {
                ToastHelper.showError(res);
            }
        } else {
            if (assignmentMode === 'SELF' && item?.status === 'CREATED') params.status = 'TODO';
            const res = await MaintainerHelper.API.requestUpdateTicket(item.ticketId, params);
            if (_.isBoolean(res) && res) {
                ToastHelper.showSuccess('Chỉnh sửa thông tin công việc thành công');
                onDone && onDone();
            } else if (_.isString(res)) {
                ToastHelper.showError(res);
            }
        }
        setLoading(false);
    };

    const dropdownChargeStationEl = useMemo(() => {
        return (
            <CustomDropdown2
                id="stationId_dialog"
                name="stationId_dialog"
                ignoreConfirmClick={true}
                toggleElement={
                    <button
                        className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between
                           ${readyToValidate && !Utils.isValid(selectedChargeStation) ? 'button-invalid' : ''} `}
                        type="button"
                    >
                        {selectedChargeStation?.name ?? 'Chọn trạm sạc'}
                    </button>
                }
                selectedValue={selectedChargeStation}
                dropdownMenuItems={[{ name: 'Trạm sạc', role: 'STATION' }]}
                getSubItems={async (item) => {
                    try {
                        return await ChargeHelper.API.requestGetChargeStationList(
                            Utils.filterParams({
                                page: item?.page || 0,
                                limit: 10,
                                q: item?.q || '',
                            })
                        ).then((data) => {
                            return {
                                values: data.chargeStations?.map((station) => ({
                                    id: station?.stationId,
                                    name: station?.name,
                                    item: station,
                                })),
                                total: data.total,
                            };
                        });
                    } catch (error) {
                        console.error('Error fetching station list:', error);
                        return { values: [], total: 0 };
                    }
                }}
                dropdownMenuStyle={{ maxHeight: '30vh' }}
                dropdownMenuClassName="overflow-auto w-100"
                onChange={(value) => {
                    setSelectedChargeStation(value);
                }}
                isDropdownForm={true}
                titleSearchable={true}
                searchable={true}
                searchFormClassName="mx-3 my-1 search-form-border"
                defaultValue={{
                    name: 'Trạm sạc',
                    role: 'STATION',
                }}
                idCheckType='id'
                footerEl={
                    <div
                        className="p-4 position-sticky sticky-bottom bg-white"
                        style={{
                            borderTop: `1px solid ${AppColors.gray[300]}`,
                        }}
                    >
                        {UIHelper.buildNegativeButton('Bỏ chọn', () => {
                            setSelectedChargeStation(null);
                        })}
                    </div>
                }
            />
        );
    }, [selectedChargeStation, readyToValidate]);

    const dropdownChargePointEl = useMemo(() => {
        return (
            <CustomDropdown2
                id="pointId_dialog"
                name="pointId_dialog"
                ignoreConfirmClick={true}
                toggleElement={
                    <button
                        className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between
                                ${!selectedChargeStation?.id ? 'dropdown-disabled' : ''}
                                ${readyToValidate && !Utils.isValid(selectedChargePoint) ? 'button-invalid' : ''}
                            `}
                        type="button"
                    >
                        {selectedChargePoint?.name ?? 'Chọn trụ sạc'}
                    </button>
                }
                selectedValue={selectedChargePoint}
                dropdownMenuItems={[{ name: 'Trụ sạc', role: 'POINT' }]}
                getSubItems={async (item) => {
                    try {
                        if (!selectedChargeStation?.id) return;
                        return await ChargeHelper.API.requestGetChargePointList(
                            Utils.filterParams({
                                page: item?.page || 0,
                                limit: 10,
                                q: item?.q || '',
                                stationId: selectedChargeStation?.id,
                            })
                        ).then((data) => {
                            return {
                                values: data.chargePoints?.map((point) => ({
                                    id: point?.pointId,
                                    name: point?.pointCode,
                                    item: point,
                                })),
                                total: data.total,
                            };
                        });
                    } catch (error) {
                        console.error('Error fetching point list:', error);
                        return { values: [], total: 0 };
                    }
                }}
                dropdownMenuStyle={{ maxHeight: '30vh' }}
                dropdownMenuClassName="overflow-auto w-100"
                onChange={(value) => {
                    setSelectedChargePoint(value);
                }}
                isDropdownForm={true}
                titleSearchable={true}
                searchable={true}
                searchFormClassName="mx-3 my-1 search-form-border"
                defaultValue={{
                    name: 'Trụ sạc',
                    role: 'POINT',
                }}
                idCheckType='id'
                footerEl={
                    <div
                        className="p-4 position-sticky sticky-bottom bg-white"
                        style={{
                            borderTop: `1px solid ${AppColors.gray[300]}`,
                        }}
                    >
                        {UIHelper.buildNegativeButton('Bỏ chọn', () => {
                            setSelectedChargeStation(null);
                        })}
                    </div>
                }
                disabled={!selectedChargeStation?.id}
            />
        );
    }, [selectedChargeStation, selectedChargePoint, readyToValidate]);

    const handleFilesChanged = (e) => {
        const newFiles = e.target.files;
        if (!newFiles || newFiles?.length === 0) return;

        const filesArray = Array.from(newFiles);
        const validFiles = [];

        const MAX_SIZE_MB = 100;

        filesArray.forEach((file) => {
            const sizeInMB = file.size / (1024 * 1024);
            if (sizeInMB > MAX_SIZE_MB) {
                ToastHelper.showError(`File "${file.name}" vượt quá ${MAX_SIZE_MB}MB.`);
                return;
            }

            validFiles.push({
                file,
                preview: URL.createObjectURL(file),
                type: file.type,
            });
        });

        if (validFiles?.length > 0) {
            const tmpSelectedFiles = [...selectedFiles, ...validFiles];
            setSelectedFiles(tmpSelectedFiles);
        }

        e.target.value = null;
    };

    const handleRemoveFile = (index) => {
        const tmp = [...selectedFiles];
        URL.revokeObjectURL(tmp[index].preview);
        tmp.splice(index, 1);
        setSelectedFiles(tmp);
    };

    return (
        <div>
            <div className="row m-0 p-0 px-2 mt-4">
                {/* stationId */}
                <div className="col-md-6 mb-4 px-2">
                    {UIHelper.buildFormLabel('Trạm sạc', true)}
                    {dropdownChargeStationEl}
                </div>
                {/* pointId */}
                <div className="col-md-6 mb-4 px-2">
                    {UIHelper.buildFormLabel('Trụ sạc lỗi', true)}
                    {dropdownChargePointEl}
                </div>
                {/* type */}
                <div className="col-md-6 mb-4 px-2">
                    {UIHelper.buildFormLabel('Loại công việc', true)}
                    <KTBSDropdown
                        toggleElement={({ showError }) => (
                            <button
                                className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${showError ? 'button-invalid' : ''}`}
                                type="button"
                            >
                                {_.find(
                                    MaintainerHelper.Data.ticketTypeOptions,
                                    (item) => item.value === type
                                )?.name ?? 'Chọn loại công việc'}
                            </button>
                        )}
                        selectedValue={type}
                        dropdownMenuItems={MaintainerHelper.Data.ticketTypeOptions}
                        dropdownMenuStyle={{ maxHeight: '30vh' }}
                        dropdownMenuClassName="overflow-auto w-100"
                        onChange={(value) => setType(value)}
                        enableCheckValid
                        isDropdownForm={true}
                        isValid={Utils.isValid(type)}
                        isTouched={readyToValidate}
                        feedbackText={readyToValidate && !Utils.isValid(type) ? "Vui lòng chọn loại công việc" : ''}
                    />
                </div>
                {/* priority */}
                <div className="col-md-6 mb-4 px-2">
                    {UIHelper.buildFormLabel('Độ ưu tiên', true)}
                    <KTBSDropdown
                        toggleElement={({ showError }) => (
                            <button
                                className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${showError ? 'button-invalid' : ''}`}
                                type="button"
                            >
                                {_.find(
                                    MaintainerHelper.Data.ticketPriorityOptions,
                                    (item) => item.value === priority
                                )?.name ?? 'Chọn độ ưu tiên'}
                            </button>
                        )}
                        selectedValue={priority}
                        dropdownMenuItems={MaintainerHelper.Data.ticketPriorityOptions}
                        dropdownMenuStyle={{ maxHeight: '30vh' }}
                        dropdownMenuClassName="overflow-auto w-100"
                        onChange={(value) => setPriority(value)}
                        enableCheckValid
                        isDropdownForm={true}
                        isValid={Utils.isValid(priority)}
                        isTouched={readyToValidate}
                        feedbackText={readyToValidate && !Utils.isValid(priority) ? "Vui lòng chọn độ ưu tiên" : ''}
                    />
                </div>
                {/* deadline */}
                <div className="col-md-6 mb-4 px-2">
                    {UIHelper.buildFormLabel('Thời gian cần xử lý', true)}
                    <KTFormInput
                        name="contractValidFrom"
                        placeholder="Chọn thời gian cần xử lý"
                        type={KTFormInputType.date}
                        value={deadline}
                        onChange={(value) => setDeadline(value)}
                        minTime={moment()}
                        enableCheckValid={readyToValidate}
                        isValid={Utils.isValid(deadline)}
                        isTouched={readyToValidate}
                    />
                </div>
                {/* assignmentMode */}
                <div className="col-md-6 mb-4 px-2">
                    {UIHelper.buildFormLabel('Kiểu phân phối công việc', true)}
                    <KTBSDropdown
                        toggleElement={({ showError }) => (
                            <button
                                className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${showError ? 'button-invalid' : ''}`}
                                type="button"
                            >
                                {_.find(
                                    MaintainerHelper.Data.assignmentModeOptions,
                                    (item) => item.value === assignmentMode
                                )?.name ?? 'Chọn kiểu phân phối'}
                            </button>
                        )}
                        selectedValue={assignmentMode}
                        dropdownMenuItems={MaintainerHelper.Data.assignmentModeOptions}
                        dropdownMenuStyle={{ maxHeight: '30vh' }}
                        dropdownMenuClassName="overflow-auto w-100"
                        onChange={(value) => setAssignmentMode(value)}
                        enableCheckValid
                        isDropdownForm={true}
                        isValid={Utils.isValid(assignmentMode)}
                        isTouched={readyToValidate}
                        feedbackText={readyToValidate && !Utils.isValid(assignmentMode) ? "Vui lòng chọn kiểu phân phối" : ''}
                    />
                </div>
                {/* description */}
                <div className="col-md-12 mb-4 px-2">
                    {UIHelper.buildFormLabel('Mô tả lỗi', true)}
                    <KTFormTextArea
                        placeholder="Nhập mô tả lỗi"
                        rows={3}
                        name="description"
                        value={description}
                        onChange={(value) => {
                            setDescription(value);
                        }}
                        enableCheckValid={readyToValidate}
                        isValid={Utils.isValid(description)}
                        isTouched={readyToValidate}
                    />
                </div>
                {/* attachFiles */}
                <div className="col-12 mb-4 px-2">
                    <div>
                        {UIHelper.buildFormLabel('Ảnh, video hiện trạng')}
                        <div className="multi-media-upload">
                            <button
                                type="button"
                                className="upload-button border-none px-6 py-4 rounded-sm d-flex"
                                onClick={() => document.getElementById('multi-media-input').click()}
                                style={{ backgroundColor: AppColors.gray[200] }}
                            >
                                <i className="fa-regular fa-upload mr-3" style={{ color: AppColors.gray[800] }} />
                                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                                    Thêm tệp tin
                                </span>
                            </button>

                            <input
                                id="multi-media-input"
                                type="file"
                                multiple
                                accept="image/*,video/*"
                                style={{ display: 'none' }}
                                onChange={handleFilesChanged}
                            />
                            {selectedFiles?.length > 0 && (
                                <div className="preview-grid mt-4" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '5px', marginBottom: '16px' }}>
                                    {selectedFiles.map((fileObj, index) => (
                                        <div
                                            key={index}
                                            className="position-relative"
                                            style={{
                                                width: '230px',
                                                borderRadius: '8px',
                                                overflow: 'hidden',
                                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                                background: '#f8f9fa',
                                            }}
                                        >
                                            {_.isObject(fileObj)
                                                ? (
                                                    <>
                                                        {fileObj.type?.startsWith('image/') ? (
                                                            <img
                                                                src={fileObj.preview}
                                                                alt="preview"
                                                                style={{
                                                                    width: '100%',
                                                                    height: '200px',
                                                                    objectFit: 'cover',
                                                                    display: 'block',
                                                                }}
                                                            />
                                                        ) : (
                                                            <video
                                                                src={fileObj.preview}
                                                                controls
                                                                style={{
                                                                    width: '100%',
                                                                    height: '200px',
                                                                    objectFit: 'cover',
                                                                    display: 'block',
                                                                    background: '#000',
                                                                }}
                                                            />
                                                        )}
                                                    </>
                                                )
                                                : (
                                                    <>
                                                        {
                                                            (() => {
                                                                const extension = fileObj?.split('.').pop()?.toLowerCase();
                                                                const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension);

                                                                return isImage ? (
                                                                    <img
                                                                        src={Utils.getFullUrl(fileObj)}
                                                                        alt="preview"
                                                                        style={{
                                                                            width: '100%',
                                                                            height: '200px',
                                                                            objectFit: 'cover',
                                                                            display: 'block',
                                                                        }}
                                                                    />
                                                                ) : (
                                                                    <video
                                                                        src={Utils.getFullUrl(fileObj)}
                                                                        controls
                                                                        style={{
                                                                            width: '100%',
                                                                            height: '200px',
                                                                            objectFit: 'cover',
                                                                            display: 'block',
                                                                            background: '#000',
                                                                        }}
                                                                    />
                                                                );
                                                            })()
                                                        }
                                                    </>
                                                )

                                            }

                                            <button
                                                type="button"
                                                onClick={() => handleRemoveFile(index)}
                                                className="btn btn-xs btn-icon btn-circle btn-secondary"
                                                style={{
                                                    position: 'absolute',
                                                    top: '8px',
                                                    right: '8px',
                                                    zIndex: 10,
                                                }}
                                            >
                                                <i className="ki ki-bold-close icon-xs text-white" />
                                            </button>

                                            <div className="p-2 text-center">
                                                <small
                                                    className="d-block text-muted text-truncate"
                                                    style={{ maxWidth: '140px', fontSize: '11px' }}
                                                    title={fileObj.file.name}
                                                >
                                                    {fileObj.file.name}
                                                </small>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}

                        </div>
                    </div>
                </div>
            </div>
            {/* actions */}
            <div
                className="d-flex align-items-center justify-content-end gap-3 px-4 py-3"
                style={{
                    borderTop: `1px solid ${AppColors.gray[200]}`,
                }}
            >
                {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null)}
                {UIHelper.buildGreenButton(
                    !editMode ? 'Thêm công việc' : 'Cập nhật',
                    handleSubmit,
                    null,
                    false,
                    loading
                )}
            </div>
        </div>
    );
}

export default DialogAddMaintainerTicketView;
